export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\].[0-9]{1,3}\].[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const INDIAN_MOBILE_REGEX = /(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/

export const CONTACT_CONSENT_ERROR_MESSAGES = {
  consentRequired: "Please provide consent to proceed",
  emailRequired: "Email ID is required",
  emailInvalid: "Please enter a valid Email ID",
  mobileRequired: "Mobile number is required",
  mobileInvalid: "Please enter a valid mobile number",
  proposerEmailRequired: "Proposer email ID is required",
  proposerMobileRequired: "Proposer mobile number is required",
  proposerMobileInvalid: "Please enter a valid proposer mobile number",
}

export const DEFAULT_CONTACT_CONSENT_KEYS = {
  email: "email",
  contactNo: "contactNo",
  mobileNumber: "mobileNumber",
  privacyPolicy: "privacyPolicy",
  contactNumber: "contactNumber",
  contactCountryCode: "contactCountryCode",
}

export const DEFAULT_PROPOSER_CONTACT_KEYS = {
  proposerEmail: "GOPAproposerEmail",
  proposerContactNo: "GOPAnumber",
  proposerMobileNumber: "GOPAproposerCode",
}

export const CONTACT_CONSENT_CONFIG = {
  pageIndex: 0,
  pageId: "PagePromise4FutureCalculatePremium",
  personalSectionId: "SectionPromise4FutureCalculatePremiumPersonalDetails",
  keys: {
    email: "email",
    contactNo: "contactNo",
    mobileNumber: "mobileNumber",
    privacyPolicy: "privacyPolicy",
  },
  proposerKeys: {
    proposerEmail: "proposerEmail",
    proposerContactNo: "contactNoproposer",
    proposerMobileNumber: "proposerNumber",
  },
  proposerTrigger: {
    fieldKey: "islifetobeAssuredandProposer",
    requiredValue: "N",
  },
}

export const FUTURE_DOLLAR_GIFT_CITY_CONTACT_CONSENT_CONFIG = {
  pageIndex: 0,
  pageId: "PageFutureDollarGiftCityCalculateFundValue",
  personalSectionId: "FutureDollarGiftCityPersonelDetailsSection",
  keys: {
    email: "email",
    contactNo: "contactNo",
    mobileNumber: "mobileNumber",
    privacyPolicy: "privacyPolicy",
    contactNoResidence: "contactNoResidence",
    mobileNumberResidence: "mobileNumberResidence",
  },
  proposerKeys: {
    proposerEmail: "proposerEmail",
    proposerContactNo: "contactNoproposer",
    proposerMobileNumber: "proposerNumber",
    contactNoproposerResidence: "contactNoproposerResidence",
    proposerNumberResidence: "proposerNumberResidence",
  },
  proposerTrigger: {
    fieldKey: "CFislifetobeAssuredandProposer",
    requiredValue: "N",
  },
}

export const FIRST_PAGE_PERSONAL_SECTION_IDS = [
  "GAINpersonalDetailsSection",
  "CPPersonalDetailsSection",
  "SectionGuaranteedSavingsPersonelDetails",
  "SectionGOPAPersonelDetails",
  "SectionFlexiEdgeCalculatePremiumPersonalDetails",
  "SectionPromise4FutureCalculatePremiumPersonalDetails",
  "FutureDollarGiftCityPersonelDetailsSection",
]

export function hasFieldValue(value) {
  if (value === null || value === undefined) return false
  if (typeof value === "string") return value.trim() !== ""
  if (typeof value === "boolean") return value
  return Boolean(value)
}

export function normalizeContactNo(value = "") {
  return String(value).replace(/\D/g, "")
}

function getSectionDataFromJourneyData(journeyData = [], config) {
  const page = journeyData[config.pageIndex]
  if (!page?.pageData?.length) return {}

  const section =
    page.pageData.find(item => item.sectionId === config.personalSectionId) ||
    page.pageData.find(item =>
      FIRST_PAGE_PERSONAL_SECTION_IDS.includes(item.sectionId)
    ) ||
    page.pageData[0]

  return section?.sectionData || {}
}

export function isProposerContactRequired(sectionData = {}, config) {
  const trigger = config?.proposerTrigger
  if (!trigger?.fieldKey) return false
  return sectionData[trigger.fieldKey] === trigger.requiredValue
}

function includesResidenceFields(keys = {}) {
  return Boolean(keys.contactNoResidence && keys.mobileNumberResidence)
}

function includesProposerResidenceFields(proposerKeys = {}) {
  return Boolean(
    proposerKeys.contactNoproposerResidence && proposerKeys.proposerNumberResidence
  )
}

export function getContactConsentSnapshot(
  sectionData = {},
  keys = DEFAULT_CONTACT_CONSENT_KEYS,
  proposerKeys = null,
  config = null
) {
  const contactNo =
    sectionData[keys.contactNo] ?? sectionData[keys.contactNumber] ?? ""

  const snapshot = {
    email: sectionData[keys.email] ?? "",
    contactNo,
    mobileNumber:
      sectionData[keys.mobileNumber] ??
      sectionData[keys.contactCountryCode] ??
      "+91",
    privacyPolicy: Boolean(sectionData[keys.privacyPolicy]),
    requiresProposer: false,
    proposerEmail: "",
    proposerContactNo: "",
    proposerMobileNumber: "+91",
    contactNoResidence: "",
    mobileNumberResidence: "+971",
    contactNoproposerResidence: "",
    proposerNumberResidence: "+971",
  }

  if (includesResidenceFields(keys)) {
    snapshot.contactNoResidence = sectionData[keys.contactNoResidence] ?? ""
    snapshot.mobileNumberResidence =
      sectionData[keys.mobileNumberResidence] ?? "+971"
  }

  if (proposerKeys) {
    snapshot.requiresProposer = isProposerContactRequired(
      sectionData,
      config || { proposerTrigger: {} }
    )
    snapshot.proposerEmail = sectionData[proposerKeys.proposerEmail] ?? ""
    snapshot.proposerContactNo =
      sectionData[proposerKeys.proposerContactNo] ?? ""
    snapshot.proposerMobileNumber =
      sectionData[proposerKeys.proposerMobileNumber] ?? "+91"

    if (includesProposerResidenceFields(proposerKeys)) {
      snapshot.contactNoproposerResidence =
        sectionData[proposerKeys.contactNoproposerResidence] ?? ""
      snapshot.proposerNumberResidence =
        sectionData[proposerKeys.proposerNumberResidence] ?? "+971"
    }
  }

  return snapshot
}

export function isContactEntered(snapshot) {
  return (
    hasFieldValue(snapshot.email) ||
    hasFieldValue(snapshot.contactNo) ||
    hasFieldValue(snapshot.contactNoResidence)
  )
}

export function isProposerContactEntered(snapshot) {
  return (
    hasFieldValue(snapshot.proposerEmail) ||
    hasFieldValue(snapshot.proposerContactNo) ||
    hasFieldValue(snapshot.contactNoproposerResidence)
  )
}

export function isConsentRequiredOnFirstPage(snapshot) {
  return isContactEntered(snapshot) || isProposerContactEntered(snapshot)
}

export function shouldShowBiContactConsentPopup(snapshot, config = null) {
  const keys = config?.keys || {}
  const proposerKeys = config?.proposerKeys || {}
  const hasResidence = includesResidenceFields(keys)

  const laMissing =
    !hasFieldValue(snapshot.email) ||
    !snapshot.privacyPolicy ||
    (hasResidence && !hasFieldValue(snapshot.contactNoResidence))

  if (laMissing) return true

  if (snapshot.requiresProposer) {
    const proposerMissing =
      !hasFieldValue(snapshot.proposerEmail) ||
      (includesProposerResidenceFields(proposerKeys) &&
        !hasFieldValue(snapshot.contactNoproposerResidence))

    if (proposerMissing) return true
  }

  return false
}

export function canSendBiEmailFromJourneyData(
  journeyData = [],
  config = CONTACT_CONSENT_CONFIG
) {
  const snapshot = getContactConsentFromJourneyData(journeyData, config)
  if (!hasFieldValue(snapshot.email)) {
    return false
  }
  if (snapshot.requiresProposer && !hasFieldValue(snapshot.proposerEmail)) {
    return false
  }
  return true
}

export function isFirstPageContactConsentStep(
  currentPageIndex,
  currentSectionIndex,
  showFirstSectionFields
) {
  return (
    currentPageIndex === 0 &&
    currentSectionIndex === 0 &&
    showFirstSectionFields === false
  )
}

export function validateFirstPageContactConsent(
  sectionData,
  keys = DEFAULT_CONTACT_CONSENT_KEYS,
  proposerKeys = null,
  config = null
) {
  const snapshot = getContactConsentSnapshot(
    sectionData,
    keys,
    proposerKeys,
    config
  )
  const errors = {}

  if (isConsentRequiredOnFirstPage(snapshot) && !snapshot.privacyPolicy) {
    errors[keys.privacyPolicy] = CONTACT_CONSENT_ERROR_MESSAGES.consentRequired
  }


  return {
    isValid: Object.keys(errors).length === 0,
    errors,
    snapshot,
  }
}

function validateEmailField(email, errors, errorKey, requiredMessage) {
  const normalized = (email || "").trim().toLowerCase()
  if (!hasFieldValue(normalized)) {
    errors[errorKey] = requiredMessage
  } else if (!EMAIL_REGEX.test(normalized)) {
    errors[errorKey] = CONTACT_CONSENT_ERROR_MESSAGES.emailInvalid
  }
  return normalized
}

function validateMobileField(contactNo, errors, errorKey, requiredMessage, mobileNumber) {
  const normalized = normalizeContactNo(contactNo)
  if (!hasFieldValue(normalized)) {
    errors[errorKey] = requiredMessage
  } else {
    const isIndian = mobileNumber === "+91"
    if (isIndian) {
      if (normalized.length !== 10 || !INDIAN_MOBILE_REGEX.test(normalized)) {
        errors[errorKey] = CONTACT_CONSENT_ERROR_MESSAGES.mobileInvalid
      }
    } else {
      if (normalized.length < 7 || normalized.length > 15) {
        errors[errorKey] = CONTACT_CONSENT_ERROR_MESSAGES.mobileInvalid
      }
    }
  }
  return normalized
}

function validatePhoneByCountryCode(
  contactNo,
  countryCode,
  errors,
  errorKey,
  { required = true } = {}
) {
  const normalized = normalizeContactNo(contactNo)
  if (!hasFieldValue(normalized)) {
    if (required) {
      errors[errorKey] = CONTACT_CONSENT_ERROR_MESSAGES.mobileRequired
    }
  } else {
    const isIndian = countryCode === "+91"
    if (isIndian) {
      if (normalized.length !== 10 || !INDIAN_MOBILE_REGEX.test(normalized)) {
        errors[errorKey] = CONTACT_CONSENT_ERROR_MESSAGES.mobileInvalid
      }
    } else {
      if (normalized.length < 7 || normalized.length > 15) {
        errors[errorKey] = CONTACT_CONSENT_ERROR_MESSAGES.mobileInvalid
      }
    }
  }
  return normalized
}

export function validateBiContactConsentPopup(values, config = null) {
  const errors = {}
  const keys = config?.keys || {}
  const proposerKeys = config?.proposerKeys || {}
  const hasResidence = includesResidenceFields(keys)

  const email = validateEmailField(
    values.email,
    errors,
    "email",
    CONTACT_CONSENT_ERROR_MESSAGES.emailRequired
  )

  let contactNo = ""
  let mobileNumber = values.mobileNumber || "+91"
  let contactNoResidence = ""
  let mobileNumberResidence = values.mobileNumberResidence || "+971"

  if (hasResidence) {
    contactNoResidence = validatePhoneByCountryCode(
      values.contactNoResidence,
      values.mobileNumberResidence || "+971",
      errors,
      "contactNoResidence",
      { required: true }
    )
    mobileNumberResidence = values.mobileNumberResidence || "+971"

    if (hasFieldValue(values.contactNo)) {
      contactNo = validatePhoneByCountryCode(
        values.contactNo,
        values.mobileNumber || "+91",
        errors,
        "contactNo",
        { required: false }
      )
    } else {
      contactNo = normalizeContactNo(values.contactNo)
    }
    mobileNumber = values.mobileNumber || "+91"
  } else {
    contactNo = validateMobileField(
      values.contactNo,
      errors,
      "contactNo",
      CONTACT_CONSENT_ERROR_MESSAGES.mobileRequired,
      values.mobileNumber
    )
    mobileNumber = values.mobileNumber || "+91"
  }

  if (!values.privacyPolicy) {
    errors.privacyPolicy = CONTACT_CONSENT_ERROR_MESSAGES.consentRequired
  }

  let proposerEmail = ""
  let proposerContactNo = ""
  let proposerMobileNumber = values.proposerMobileNumber || "+91"
  let contactNoproposerResidence = ""
  let proposerNumberResidence = values.proposerNumberResidence || "+971"

  if (values.requiresProposer) {
    proposerEmail = validateEmailField(
      values.proposerEmail,
      errors,
      "proposerEmail",
      CONTACT_CONSENT_ERROR_MESSAGES.proposerEmailRequired
    )

    if (includesProposerResidenceFields(proposerKeys)) {
      contactNoproposerResidence = validatePhoneByCountryCode(
        values.contactNoproposerResidence,
        values.proposerNumberResidence || "+971",
        errors,
        "contactNoproposerResidence",
        { required: true }
      )
      proposerNumberResidence = values.proposerNumberResidence || "+971"

      if (hasFieldValue(values.proposerContactNo)) {
        proposerContactNo = validatePhoneByCountryCode(
          values.proposerContactNo,
          values.proposerMobileNumber || "+91",
          errors,
          "proposerContactNo",
          { required: false }
        )
      } else {
        proposerContactNo = normalizeContactNo(values.proposerContactNo)
      }
      proposerMobileNumber = values.proposerMobileNumber || "+91"
    } else {
      proposerContactNo = validateMobileField(
        values.proposerContactNo,
        errors,
        "proposerContactNo",
        CONTACT_CONSENT_ERROR_MESSAGES.proposerMobileRequired,
        values.proposerMobileNumber
      )
      proposerMobileNumber = values.proposerMobileNumber || "+91"
    }
  }

  const normalizedValues = {
    email,
    contactNo,
    mobileNumber,
    privacyPolicy: Boolean(values.privacyPolicy),
    requiresProposer: Boolean(values.requiresProposer),
    proposerEmail,
    proposerContactNo,
    proposerMobileNumber,
  }

  if (hasResidence) {
    normalizedValues.contactNoResidence = contactNoResidence
    normalizedValues.mobileNumberResidence = mobileNumberResidence
  }

  if (values.requiresProposer && includesProposerResidenceFields(proposerKeys)) {
    normalizedValues.contactNoproposerResidence = contactNoproposerResidence
    normalizedValues.proposerNumberResidence = proposerNumberResidence
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
    normalizedValues,
  }
}

export function getContactConsentFromJourneyData(
  journeyData = [],
  config = CONTACT_CONSENT_CONFIG
) {
  const sectionData = getSectionDataFromJourneyData(journeyData, config)
  return getContactConsentSnapshot(
    sectionData,
    config.keys,
    config.proposerKeys,
    config
  )
}

export function mergeContactConsentIntoJourneyData(
  journeyData = [],
  values,
  config = CONTACT_CONSENT_CONFIG
) {
  const updatedJourneyData = JSON.parse(JSON.stringify(journeyData || []))
  const pageIndex = config.pageIndex ?? 0

  if (!updatedJourneyData[pageIndex]) {
    updatedJourneyData[pageIndex] = {
      pageId: config.pageId,
      pageData: [],
    }
  }

  const pageData = updatedJourneyData[pageIndex].pageData || []
  let sectionIndex = pageData.findIndex(
    item => item.sectionId === config.personalSectionId
  )

  if (sectionIndex === -1) {
    pageData.unshift({
      sectionId: config.personalSectionId,
      sectionData: {},
    })
    sectionIndex = 0
  }

  const keys = config.keys
  const proposerKeys = config.proposerKeys || {}
  const sectionDataPatch = {
    ...(pageData[sectionIndex]?.sectionData || {}),
    [keys.email]: values.email,
    [keys.contactNo]: values.contactNo,
    [keys.mobileNumber]: values.mobileNumber || "+91",
    [keys.privacyPolicy]: values.privacyPolicy,
  }

  if (includesResidenceFields(keys)) {
    sectionDataPatch[keys.contactNoResidence] = values.contactNoResidence
    sectionDataPatch[keys.mobileNumberResidence] =
      values.mobileNumberResidence || "+971"
  }

  if (values.requiresProposer && proposerKeys.proposerEmail) {
    sectionDataPatch[proposerKeys.proposerEmail] = values.proposerEmail
    sectionDataPatch[proposerKeys.proposerContactNo] = values.proposerContactNo
    sectionDataPatch[proposerKeys.proposerMobileNumber] =
      values.proposerMobileNumber || "+91"

    if (includesProposerResidenceFields(proposerKeys)) {
      sectionDataPatch[proposerKeys.contactNoproposerResidence] =
        values.contactNoproposerResidence
      sectionDataPatch[proposerKeys.proposerNumberResidence] =
        values.proposerNumberResidence || "+971"
    }
  }

  pageData[sectionIndex] = {
    ...pageData[sectionIndex],
    sectionData: sectionDataPatch,
  }

  updatedJourneyData[pageIndex].pageData = pageData
  return updatedJourneyData
}

export function buildContactConsentConditionPatch(
  config = CONTACT_CONSENT_CONFIG,
  values
) {
  const keys = config.keys
  const proposerKeys = config.proposerKeys || {}
  const prefix = `${config.pageId}.${config.personalSectionId}`
  const patch = {
    [`${prefix}.${keys.email}`]: values.email,
    [`${prefix}.${keys.contactNo}`]: values.contactNo,
    [`${prefix}.${keys.mobileNumber}`]: values.mobileNumber || "+91",
    [`${prefix}.${keys.privacyPolicy}`]: values.privacyPolicy,
  }

  if (includesResidenceFields(keys)) {
    patch[`${prefix}.${keys.contactNoResidence}`] = values.contactNoResidence
    patch[`${prefix}.${keys.mobileNumberResidence}`] =
      values.mobileNumberResidence || "+971"
  }

  if (values.requiresProposer && proposerKeys.proposerEmail) {
    patch[`${prefix}.${proposerKeys.proposerEmail}`] = values.proposerEmail
    patch[`${prefix}.${proposerKeys.proposerContactNo}`] =
      values.proposerContactNo
    patch[`${prefix}.${proposerKeys.proposerMobileNumber}`] =
      values.proposerMobileNumber || "+91"

    if (includesProposerResidenceFields(proposerKeys)) {
      patch[`${prefix}.${proposerKeys.contactNoproposerResidence}`] =
        values.contactNoproposerResidence
      patch[`${prefix}.${proposerKeys.proposerNumberResidence}`] =
        values.proposerNumberResidence || "+971"
    }
  }

  return patch
}
